module.exports = __webpack_public_path__ + "img/news.76c67f85.jpg";